module.exports = __webpack_public_path__ + "img/51_52.8de412ea.png";